import { Component, OnInit } from '@angular/core';

@Component({
    standalone: false,
  selector: 'app-console-maintenance',
  templateUrl: './console-maintenance.component.html',
  styleUrls: ['./console-maintenance.component.scss']
})
export class ConsoleMaintenanceComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
